import { Entity, Lex, ProjectViewFilters } from '../index';

export enum ProjectViewVisibility {
    Private = 'Private',
    Public = 'Public',
    Shared = 'Shared'
}

export enum ProjectSystemViewName {
    MyProjects = 'My Projects',
}

export enum ProjectViewDisplayType {
    Kanban = 'Kanban',
    Grid = 'Grid'
}

export type ProjectViewSortType = 'ASC' | 'DESC';

export enum ProjectViewSortBy {
    None = 'none',
    Name = 'name',
    CreatedDate = 'createdAt',
    StartDate = 'sorting.startDate',
    EndDate = 'sorting.endDate',
}

export interface ProjectViewSortOptions {
    sortBy: ProjectViewSortBy;
    sortType: ProjectViewSortType;
}

export interface ProjectViewSummary {
    _id: string;
    name: string;
    visibility: ProjectViewVisibility;
    displayType: ProjectViewDisplayType;
    sort?: ProjectViewSortOptions;
    card: ProjectViewCardFields,
    list: ProjectViewListField[];
    isDefault: boolean;
    system: boolean;
    selected: boolean;
    ownerId?: string;
    canEditView?: boolean;
    sharedWith: Entity[]
    filters?: ProjectViewFilters;
}

export interface ProjectViewCardFields {
    projectNumber: boolean;
    status: boolean;
    account: boolean;
    owner: boolean;
    start: boolean;
    end: boolean;
    type: boolean;
    tags: boolean;
    contact: boolean;
    address: boolean;
    customFields: Entity[];
}

export interface ProjectViewListField {
    _id: string;
    name: string;
    visible: boolean;
    sortOrder: Lex;
    system: boolean;
}

export interface ProjectView extends Entity {

    description: string;
    displayType?: ProjectViewDisplayType;
    visibility?: ProjectViewVisibility;
    sharedWith?: Entity[];

    owner: Entity;
    system?: boolean;

    filters: ProjectViewFilters;
    card: ProjectViewCardFields;
    list: ProjectViewListField[];

    canEditView?: boolean;
    canShareView?: boolean;

}

export const ProjectDefaultFields = [
    { _id: 'projectNumber', name: 'Project Number', visible: true, system: true },
    { _id: 'account', name: 'Account', visible: true, system: true },
    { _id: 'status', name: 'Status', visible: true, system: true },
    { _id: 'contact', name: 'Contact', visible: true, system: true },
    { _id: 'address', name: 'Address', visible: true, system: true },
    { _id: 'owner', name: 'Owner', visible: true, system: true },
    { _id: 'start', name: 'Start Date', visible: true, system: true },
    { _id: 'end', name: 'End Date', visible: true, system: true },
    { _id: 'type', name: 'Type', visible: true, system: true },
    { _id: 'tags', name: 'Tags', visible: true, system: true },
] as ProjectViewListField[];

export const ProjectViewCardDefaults = {
    projectNumber: true,
    status: true,
    account: true,
    owner: true,
    start: true,
    end: true,
    type: true,
    customFields: [],
    address: true,
    tags: true,
} as ProjectViewCardFields;

export function emptyProjectView(data?: Partial<ProjectView>) {
    return {
        name: null,
        description: null,
        displayType: ProjectViewDisplayType.Kanban,
        visibility: ProjectViewVisibility.Private,
        sharedWith: [],
        filters: {},
        card: { ...ProjectViewCardDefaults },
        list: [...ProjectDefaultFields],
        ...data,
    } as ProjectView;
}